import { createSlice } from "@reduxjs/toolkit";
import {
    fetchAttemptScoreTableColumnNames,
    fetchAllAttemptScore,
    createAttemptScore,
    updateAttemptScore,
    deleteAttemptScore,
    activateDeactivateAttemptScore
} from "./thunk";
import { toast } from "react-toastify";

const attemptScoreSlice = createSlice({
  name: "AttemptScore",
  initialState: {
    attemptScore: [],
    tableColumnNames: [],
    loading: false,
    Headerload: false,
    error: null,
  },
  extraReducers: (builder) => {
    builder

      // Fetch Attempt Score Table Column Names
      .addCase(fetchAttemptScoreTableColumnNames.pending, (state) => {
        state.Headerload = true;
        state.error = null;
      })
      .addCase(fetchAttemptScoreTableColumnNames.fulfilled, (state, action) => {
        state.Headerload = false;
        state.tableColumnNames = action.payload;
      })
      .addCase(fetchAttemptScoreTableColumnNames.rejected, (state, action) => {
        state.Headerload = false;
        state.error = action.payload;
      })

      // Get All Attempt Score
      .addCase(fetchAllAttemptScore.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchAllAttemptScore.fulfilled, (state, action) => {
        state.loading = false;
        state.attemptScore = action.payload;
      })
      .addCase(fetchAllAttemptScore.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      // Add Attempt Score
      .addCase(createAttemptScore.pending, (state) => {
        state.error = null;
      })
      .addCase(createAttemptScore.fulfilled, (state, action) => {
        state.attemptScore = [action.payload.data[0], ...state.attemptScore];
      })
      .addCase(createAttemptScore.rejected, (state, action) => {
        state.error = action.payload;
      })

      // Update Attempt Score
      .addCase(updateAttemptScore.pending, (state) => {
        state.error = null;
      })
      .addCase(updateAttemptScore.fulfilled, (state, action) => {
        const index = state.attemptScore.findIndex(
          (item) => item.ID === action.payload[0].ID
        );

        if (index !== -1) {
          state.attemptScore[index] = action.payload[0];
        }
      })
      .addCase(updateAttemptScore.rejected, (state, action) => {
        state.error = action.payload;
      })

      // Delete Attempt Score
      .addCase(deleteAttemptScore.pending, (state) => {
        state.error = null;
      })
      .addCase(deleteAttemptScore.fulfilled, (state, action) => {
        const deletedIds = action.payload.map((item) => item.ID);

        // Filter out the deleted items
        state.attemptScore = state.attemptScore.filter(
          (item) => !deletedIds.includes(item.ID)
        );

      })
      .addCase(deleteAttemptScore.rejected, (state, action) => {
        state.error = action.payload;
      })

      // Active Deactive Attempt Score
      .addCase(activateDeactivateAttemptScore.pending, (state) => {
        state.error = null;
      })
      .addCase(activateDeactivateAttemptScore.fulfilled, (state, action) => {
        if (action.payload) {
          const updatedAttemptScore = action.payload[0];

          state.attemptScore = state.attemptScore.map((item) => item.ID === updatedAttemptScore.ID ? {...item, IsActive: updatedAttemptScore.IsActive} : item)
        }
      })
      .addCase(activateDeactivateAttemptScore.rejected, (state, action) => {
        state.error = action.payload;
      })
    },
});

export default attemptScoreSlice.reducer;